module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Chaitanya Deorukhkar","short_name":"Chaitanya","start_url":"/","background_color":"#ffffff","theme_color":"#1d1d1f","display":"standalone","theme_color_in_head":false,"icon":"static/icon.png","cache_busting_mode":"name","icon_options":{"purpose":"maskable"},"legacy":true,"crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"f41983093949274fbf979292dff2bca5"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"/vercel/path0/src/components/layout/Base.js"},
    },{
      plugin: require('../node_modules/gatsby-plugin-twitter/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-amplitude-analytics/gatsby-browser.js'),
      options: {"plugins":[],"apiKey":"7113a3213bfdd861c7dea0615d8b85e3","head":false,"respectDNT":false,"exclude":[],"eventTypes":{"outboundLinkClick":"Outbound Link Clicked","pageView":"Page Visited"},"amplitudeConfig":{"saveEvents":true,"includeUtm":true,"includeReferrer":true},"environments":["production","development"]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
